import { useState } from 'react';
import { PhoneCall } from 'lucide-react';
import { EightXEightCallsModal, EIGHT_X_EIGHT_LIME } from './EightXEightCallsBar';

const enconOrange = '#ee7203';

/**
 * Header quick-note button — sits immediately left of the Transport icon in
 * the global header's centre group (Call | Transport | Search, all centred).
 * Opens the 8x8 Calls modal straight onto a fresh blank Note so a rep taking
 * a call can jot it down immediately — the backend links it to the actual
 * call once 8x8's CDR data for that call is polled (see call_matching.py's
 * _link_quick_notes_to_call). A brand-new blank note is created every time
 * this button is pressed (not resumed from a previous session), matching
 * "opens the notes page with a new blank note".
 *
 * Unconditionally rendered — like the rest of the 8x8 Quick Call Notes
 * feature (EightXEightCallsBar.jsx's Notes tab, the backend endpoints),
 * this is NOT gated behind a Manage Changes flag: `code_changes` toggles
 * live in each environment's own database, so a flag switched on in preview
 * never carries over to production once deployed — every other file in this
 * feature was deliberately written without a runtime flag check for exactly
 * that reason. This file previously used `useFeatureFlag('header-quick-call-
 * note-button')`, which is why the icon rendered fine in preview but never
 * appeared on the deployed site.
 */
const QuickCallNoteButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        data-testid="header-quick-call-note-btn"
        onClick={() => setOpen(true)}
        className="hidden md:flex p-2.5 md:p-3 rounded-xl transition-all duration-200 items-center hover:shadow-lg hover:scale-105"
        style={{ background: 'white', boxShadow: `0 2px 10px ${EIGHT_X_EIGHT_LIME}55` }}
        title="Quick Call Note"
      >
        <PhoneCall className="w-6 h-6 md:w-7 md:h-7" style={{ color: enconOrange }} strokeWidth={2.25} />
      </button>
      <EightXEightCallsModal open={open} onClose={() => setOpen(false)} initialTab="notes" autoCreateNote />
    </>
  );
};

export default QuickCallNoteButton;
